import Header from '@components/Header/Header'
import Markdown from 'markdown-to-jsx'
import { privacyContent } from './privacyContent'

import './Privacy.css'
import Footer from '@components/Footer/Footer'

export default function Privacy() {
  return (
    <div id="privacy" className="page">
      <Header />
      <div className="container">
        <Markdown>{privacyContent}</Markdown>
      </div>
      <Footer />
    </div>
  )
}
